import { getHttpErrorMessage } from "../http-error-message/http-error-message";

// Codes the coupon batch endpoints answer with, worded for the page banner under COMPONENTS.COUPON_BATCHES.errors
const COUPON_BATCH_ERROR_CODES = [
  "BATCH_NOT_FOUND",
  "COUPON_ID_BATCH_ID_MISMATCH",
  "ON_DEMAND_BATCH_HAS_NO_UNCLAIMED_CODES",
  "ONLY_ON_DEMAND_BATCHES_CAN_BE_REMOVED",
  "DYNAMIC_REWARD_REQUIRES_ON_DEMAND_FIXED_COUPON",
  "FIXED_REWARD_REQUIRES_COUPON_VALUE",
];

export const getCouponBatchErrorMessage = (error: unknown): string => {
  const message = getHttpErrorMessage(error, "TOAST.error.title");
  return COUPON_BATCH_ERROR_CODES.includes(message) ? `COMPONENTS.COUPON_BATCHES.errors.${message}` : message;
};
